import React from 'react';
import { TableBody } from '@mui/material';

export default function TableBodyWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <TableBody>{children}</TableBody>;
}
